InputView  = require "views/input"
SliderView = require "engine/slider/view"

class SliderSurveyView extends SliderView
  template: require("./template")

  events: ->
    "iostap .btn-done": "nextSlide"

  show: ->
    @setEl @findOne(".slider-label-min"), "min-label"
    @setEl @findOne(".slider-label-max"), "max-label"

    super

  userInput: ->
    question:
      id: @options.data.question.id
      content: @options.data.question.content
    answer:
      value: parseFloat(@currentValue)

  nextSlide: ->
    InputView::nextSlide.call this

  onDrag: (draggy) ->
    super
    @styleLabels(draggy)

  onDrop: (draggy) ->
    super
    @styleLabels(draggy)

  styleLabels: (draggy) ->
    opacity = draggy.x / draggy.offset.width
    min     = 0.1
    opacity = (opacity * (1 - min)) + min
    if @options.config().direction is "rtl"
      opacity = 1 - opacity
    @getEl("min-label")?.style.opacity = (1 + min) - opacity
    @getEl("max-label")?.style.opacity = opacity

module.exports = SliderSurveyView
